<template>
  <div>
    <b-modal
      id="addcontact-modal"
      style="justify-content: space-around"
      hide-footer
      title="مخاطب جدید"
    >
      <b-alert variant="danger" :show="errors.length > 0">
        <p v-for="x in errors" v-bind:key="x">{{ x }}</p>
      </b-alert>
      <b-form @submit.stop.prevent="onSubmit">
        <div>
          <b-row>
            <b-col>
              <b-form-group
                id="input-group-1"
                label="نام: "
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  required
                  v-model="Input.name"
                  placeholder="نام"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="input-group-1"
                label="موبایل 1: "
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  required
                  v-model="Input.mobile1"
                  placeholder="موبایل 1"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="input-group-1"
                label="موبایل 2: "
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  v-model="Input.mobile2"
                  placeholder="موبایل 2"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="input-group-1"
                label="تلفن: "
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  v-model="Input.phone"
                  placeholder="تلفن"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                id="input-group-1"
                label="ایمیل: "
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  required
                  v-model="Input.email"
                  placeholder="ایمیل"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </div>

        <b-row class="mt-3">
          <b-col>
            <b-button
              style="width: 100%"
              variant="danger"
              @click="hideAddContactModal"
              >بازگشت</b-button
            >
          </b-col>
          <b-col>
            <b-button style="width: 100%" variant="primary" @click="addContact"
              >ذخیره</b-button
            >
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
  </div>
</template>

<style>
.aligner {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import httpHelper from "@/helpers/httpHelper";
import persianDate from "../../../helpers/persianDate";
import MDDropdown from "../../../components/MDDropdown";

export default {
  name: "AddContact",
  components: {
    persianDate,
    MDDropdown,
  },
  props: ["afterdone", "customer_id", "contact_id"],
  data: function () {
    return {
      Input: {
        id: 0,
        name: null,
        mobile1: null,
        mobile2: null,
        email: null,
        phone: null,
        customer_id: 0,
        contact_id: 0,
      },
      errors: [],
    };
  },

  watch: {
    contact_id: function (newVal, oldVal) {
      this.errors = [];
      if (newVal != null) {
        this.EditContact();
      }
    },
  },
  methods: {
    hideAddContactModal: function () {
      this.errors = [];
      this.$bvModal.hide("addcontact-modal");
    },
    addContact(evt) {
      this.errors = [];
      if (this.contact_id != null) {
        this.Input.id = this.contact_id;
      }
      if (this.customer_id != null) {
        this.Input.customer_id = this.customer_id;
      }

      console.log(this.Input);
      httpHelper.postData("crmcontacts", this.Input).then((response) => {
        this.errors = [];
        if (response.success) {
          this.Input.name = null;
          this.Input.mobile1 = null;
          this.Input.mobile2 = null;
          this.Input.phone = null;
          this.Input.email = null;

          this.errors = [];
          this.afterdone();
          this.hideAddContactModal();
          this.contact_id = null;
        } else {
          for (var key in response.error) {
            response.error[key].forEach((element) => {
              this.errors.push(element);
            });
          }
        }
      });
    },
    EditContact() {
      this.errors = [];

      if (this.contact_id != null) {
        this.title_modal = "ویرایش مخاطب";
        httpHelper.getData("crmcontacts?id=" + this.contact_id).then((res) => {
          if (res.success && res.result !== null) {
            this.Input = res.result;
          }
        });
      } else {
        this.title_modal = "مخاطب جدید";
        this.Input.name = null;
        this.Input.mobile1 = null;
        this.Input.mobile2 = null;
        this.Input.phone = null;
        this.Input.email = null;

        this.errors = [];
      }
    },
  },
};
</script>
